module.exports = {
  instanceSuffix: 'dev',
  apiVersion: 0,
  apiPort: 8000,
};



// WEBPACK FOOTER //
// ./src/config/config_dev.js